import React from 'react';
import { branch } from 'baobab-react/higher-order';

const SearchLoader = ({ searchLoading }) => {
	const loader = (
		<div>
			Loading&hellip;
		</div>
	);
	return searchLoading ? loader : null;
};

export default branch({
	searchLoading: ['searchLoading']
}, SearchLoader);


// WEBPACK FOOTER //
// ./src/pages/productSearch/SearchLoader.js